// @flow

import * as React from 'react';
import classNames from 'classnames';
import {Text} from 'sail/Text';
import {TooltipContainer} from 'sail/Tooltip';
import './CodeTooltip.scss';

type CodeTooltipProps = {|
  content: React.Node,
  className?: string,
  children: React.Node,
|};

export const CodeTooltip = (props: CodeTooltipProps) => {
  const {content, children, className} = props;
  const body = (
    <span className={classNames('CodeTooltip', className)}>{children}</span>
  );

  return (
    <TooltipContainer
      allowMouseOverContents
      context={body}
      tooltipContents={<Text size={13}>{content}</Text>}
      hideDelay={250}
      style={{display: 'inline'}}
      contextBoxStyle={{display: 'inline'}}
    />
  );
};
